import React, { useRef } from 'react';
import { PillButton, Row, Stack, Text } from 'library/ui';
import { LabeledField } from './LabeledField';

export function ClearinghouseRecordUploadField({
    file,
    onChange,
}: {
    file?: File;
    onChange: (file?: File) => void;
}) {
    const fileInputRef = useRef<HTMLInputElement>(null);
    return (
        <LabeledField
            label="Clearinghouse Record"
            help={
                <Stack gap="sm">
                    <Text tone="secondary">
                        Press Print in the top-right corner of the worker&rsquo;s Clearinghouse record, then save it as
                        a PDF and upload the file here.
                    </Text>
                    <Text tone="secondary">
                        <b>On a Mac:</b> in the print window, choose Save to Preview (or open the PDF dropdown and pick
                        Save as PDF), then save the file.
                    </Text>
                    <Text tone="secondary">
                        <b>On Windows:</b> in the print window, set the printer to Microsoft Print to PDF (or Save as
                        PDF), then click Print and save the file.
                    </Text>
                </Stack>
            }
            image="https://cdn.join-tandem.com/media/tandem_static/print_results_instructions.png"
        >
            <Row gap="sm">
                <PillButton variant="secondary" onClick={() => fileInputRef.current?.click()}>
                    {file ? 'Replace file' : 'Upload file'}
                </PillButton>
                {file && <Text tone="secondary">{file.name}</Text>}
            </Row>
            <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,.png,.jpg,.jpeg"
                style={{ display: 'none' }}
                onChange={(e) => onChange(e.target.files?.[0])}
            />
        </LabeledField>
    );
}
